import teamService from '@/services/team.service';

const state = {
    id: Number,
    teamOverview: Object,
    teamMembers: Array,
    teamProfessions: [],
    isLoading: Boolean
};

const getters = {
    teamOverview: (state) => state.teamOverview,
    teamMembers: (state) => state.teamMembers,
    isTeamLoading: (state) => state.isLoading,
    teamProfessions: (state) => state.teamProfessions.sort((a, b) => a.orderIndex - b.orderIndex)
};

const actions = {
    fetchTeam({commit}, id) {
        commit('setIsTeamLoading', true);
        teamService.fetchTeamById(id)
            .then(({data}) => {
                commit('setId', data.id);
                commit('setTeamOverview', data.overview);
                commit('setTeamMembers', data.members);
                commit('setTeamProfessions', data.professions);
                commit('setIsTeamLoading', false);
            })
            .catch(() => commit('setIsTeamLoading', false));
    }
};

const mutations = {
    setId: (state, id) => (state.id = id),
    setTeamOverview: (state, teamOverview) => (state.teamOverview = teamOverview),
    setTeamMembers: (state, teamMembers) => (state.teamMembers = teamMembers),
    setIsTeamLoading: (state, isLoading) => (state.isLoading = isLoading),
    setTeamProfessions: (state, teamProfessions) => (state.teamProfessions = teamProfessions),
};

export default {
    state,
    getters,
    actions,
    mutations
};